// Shared options for every Google map in the dashboard (vue2-google-maps).
//
// Owner item 1.1: the maps show the full Google base map, like the rider and
// captain apps: shop and place names, street names, POI icons and transit.
// There is deliberately NO `styles` key. The old copied vendor style
// simplified POIs, washed out street names and hid all transit; do not bring
// a style back without the owner's sign-off.
// clickableIcons:false keeps Google's place popup from opening over our own
// info windows when an operator clicks a shop icon.
//
// vue2-google-maps deep-watches the map :options prop and calls setOptions()
// whenever it sees a new object. Pass this exact constant; never build a
// variant inline in a template, in a computed or by spreading it, or the map
// is re-configured on every render (RidePage re-renders on each GPS ping).
// A page that truly needs different options gets its own frozen module
// constant here.

function deepFreeze(value) {
  if (value && typeof value === "object" && !Object.isFrozen(value)) {
    Object.values(value).forEach(deepFreeze);
    Object.freeze(value);
  }
  return value;
}

export const GOOGLE_MAP_OPTIONS = deepFreeze({
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  clickableIcons: false,
});
